import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Device } from '../types';
import { useI18n } from '../i18n';

export type DeviceTransport = 'wifi' | 'zigbee' | 'cellular' | 'both';

export function deviceTransport(device: Device): DeviceTransport | null {
  const t = device.meta?.transport;
  if (t === 'wifi' || t === 'zigbee' || t === 'cellular' || t === 'both') {
    return t;
  }
  if (device.zigbeeIeee && device.ip) {
    return 'both';
  }
  if (device.zigbeeIeee) {
    return 'zigbee';
  }
  if (device.ip) {
    return 'wifi';
  }
  return null;
}

function labelKey(transport: DeviceTransport): string {
  switch (transport) {
    case 'wifi':
      return 'devices.channelWifi';
    case 'zigbee':
      return 'devices.channelZigbee';
    case 'cellular':
      return 'devices.channelCellular';
    default:
      return 'devices.channelBoth';
  }
}

export function ChannelChip({ device }: { device: Device }) {
  const { t } = useI18n();
  const transport = deviceTransport(device);
  if (!transport) {
    return null;
  }
  const rf = Number(device.meta?.rfChannel);
  const parts = [t(labelKey(transport))];
  if (Number.isFinite(rf) && rf > 0) {
    parts.push(t('devices.channelRf', { n: rf }));
  }
  if (transport !== 'wifi' && Number.isFinite(device.lqi)) {
    parts.push(t('devices.lqi', { n: device.lqi }));
  }
  const title = parts.join(' · ');
  return (
    <Tooltip title={title}>
      <Chip label={t(labelKey(transport))} size="small" variant="outlined" />
    </Tooltip>
  );
}
